import globals from "@/util/global-whitelist.mjs";
import keyInObject from "@/util/key-in-object.mjs";

export default function getOSType() {
  // Returning literals directly allows this function to be well-typed
  const userAgent = globals.navigator?.userAgent || "";
  if (userAgent.match(/android/i) || userAgent.match(/iphone/i))
    return "mobile";
  if (userAgent.includes("Windows")) return "win32";
  if (userAgent.includes("Mac")) return "darwin";
  if (userAgent.includes("X11") || userAgent.includes("Linux")) return "linux";

  return "unknown";
}

const OS_NAMES = {
  darwin: ["home:download.macOS", "MacOS"],
  linux: ["home:download.linux", "Linux"],
  win32: ["home:download.windows", "Windows"],
};

export function getOSName(osType = getOSType()) {
  return keyInObject(OS_NAMES, osType)
    ? OS_NAMES[osType]
    : ["home:download.other", "your operating system"];
}
